const shard1 = {
  // ── DashboardHome.jsx — hero banner ──────────────────────────
  "Today": "आज",
  "Simhastha AI Command Assurance Platform": "सिंहस्थ एआय कमांड अ‍ॅश्युरन्स प्लॅटफॉर्म",
  "Kumbh AI": "कुंभ एआय",
  "Not replacing the Kumbh AI Stack.": "कुंभ एआय स्टॅक बदलत नाही.",
  "Validating, orchestrating and creating trusted, auditable governance for Simhastha-scale pilgrimage safety for CM Office, CS, NTKMA, Police, Health and all field commanders.":
    "मुख्यमंत्री कार्यालय, मुख्य सचिव, एनटीकेएमए, पोलीस, आरोग्य आणि सर्व क्षेत्रीय अधिकाऱ्यांसाठी सिंहस्थ-स्तरीय यात्रा सुरक्षिततेकरिता विश्वासार्ह व लेखापरीक्षणयोग्य प्रशासन सत्यापित, समन्वयित आणि निर्माण करते.",
  "AI Stack Assurance": "एआय स्टॅक अ‍ॅश्युरन्स",
  "Crowd Risk Digital Twin": "गर्दी जोखीम डिजिटल ट्विन",
  "Field Officer Copilot": "क्षेत्रीय अधिकारी कोपायलट",
  "Pilgrim Safety Intelligence": "यात्रेकरू सुरक्षा गुप्तचर प्रणाली",
  "Inter-Agency War Room": "आंतर-यंत्रणा वॉर रूम",
  "Service Stress Prediction": "सेवा ताण अंदाज",
  "DPDP Governance Layer": "डीपीडीपी प्रशासन स्तर",
  "ALL SYSTEMS LIVE": "सर्व प्रणाली कार्यरत",
  "Active Pilgrims": "सक्रिय यात्रेकरू",
  "Open Incidents": "खुल्या घटना",
  "AI Confidence": "एआय विश्वासार्हता",
  "Simhastha Kumbh 2027": "सिंहस्थ कुंभ 2027",
  "Nashik · Trimbakeshwar, Maharashtra": "नाशिक · त्र्यंबकेश्वर, महाराष्ट्र",

  // ── DashboardHome — section headers / chart cards (dict entries for
  // titles/subtitles auto-translated by SectionHeader / ChartCard / GaugeCard) ──
  "Executive Command KPIs": "एक्झिक्युटिव्ह कमांड केपीआय",
  "Real-time platform-wide metrics · Simhastha Kumbh 2027 · Nashik & Trimbakeshwar, Maharashtra":
    "रिअल-टाइम प्लॅटफॉर्म-व्यापी मेट्रिक्स · सिंहस्थ कुंभ 2027 · नाशिक आणि त्र्यंबकेश्वर, महाराष्ट्र",
  "LIVE": "थेट",
  "Operational Command Map": "कार्यान्वयन कमांड नकाशा",
  "Live crowd density, zone risk levels, incident overlays · Nashik city GIS view":
    "थेट गर्दी घनता, क्षेत्र जोखीम पातळी, घटना आच्छादन · नाशिक शहर जीआयएस दृश्य",
  "All Zones": "सर्व झोन",
  "Full Screen": "पूर्ण स्क्रीन",
  "Live Incident Feed": "थेट घटना फीड",
  "most recent of": "पैकी अलीकडील",
  "alerts today": "आजच्या सूचना",
  "Escalated": "वाढवलेले",
  "Open": "खुले",
  "Resolved": "निकाली",
  "Total": "एकूण",
  "Crowd Intelligence Overview": "गर्दी गुप्तचर विहंगावलोकन",
  "Actual vs. predicted crowd flow · Risk index · Simhastha peak analysis":
    "प्रत्यक्ष वि. अंदाजित गर्दी प्रवाह · जोखीम निर्देशांक · सिंहस्थ शिखर विश्लेषण",
  "Crowd Flow — Actual vs Predicted": "गर्दी प्रवाह — प्रत्यक्ष वि. अंदाजित",
  "Hourly pilgrim count · AI prediction band · Risk score overlay":
    "तासागणिक यात्रेकरू संख्या · एआय अंदाज पट्टी · जोखीम गुण आच्छादन",
  "Actual": "प्रत्यक्ष",
  "Predicted": "अंदाजित",
  "Risk Index": "जोखीम निर्देशांक",
  "Alert Severity Distribution": "अलर्ट तीव्रता वितरण",
  "Current operational status": "सद्य कार्यान्वयन स्थिती",
  "AI Assurance Score": "एआय अ‍ॅश्युरन्स गुण",
  "Overall Accuracy": "एकूण अचूकता",
  "Human Validated": "मानवाद्वारे सत्यापित",
  "False Positive Rate": "खोटे-सकारात्मक दर",
  "False Positive Control": "खोटे-सकारात्मक नियंत्रण",
  "Alert Confidence": "अलर्ट विश्वासार्हता",
  "View full AI assurance report": "संपूर्ण एआय अ‍ॅश्युरन्स अहवाल पहा",
  "Multi-Agency Operational Status": "बहु-यंत्रणा कार्यान्वयन स्थिती",
  "Real-time deployment & readiness across 6 government departments":
    "6 शासकीय विभागांमध्ये रिअल-टाइम तैनाती आणि सज्जता",
  "Route Saturation by Corridor": "मार्गिकानुसार मार्ग संपृक्तता",
  "Route saturation & crowd density by zone": "क्षेत्रानुसार मार्ग संपृक्तता आणि गर्दी घनता",
  "Emergency Resource Deployment": "आपत्कालीन संसाधन तैनाती",
  "Units deployed, available and responding": "तैनात, उपलब्ध आणि प्रतिसाद देणारी युनिट्स",
  "Service Utilisation — All Zones": "सेवा वापर — सर्व क्षेत्रे",
  "Current load percentage per service category": "सेवा प्रकारानुसार सद्य भार टक्केवारी",
  "Service Stress Intelligence": "सेवा ताण बुद्धिमत्ता",
  "Predicted overload across water, toilets, shelters, food, medical, bus, waste · NMC operational view":
    "पाणी, शौचालये, निवारा, अन्न, वैद्यकीय, बस, कचरा यामधील अंदाजित अतिभार · एनएमसी कार्यान्वयन दृश्य",
  "Shelter Load": "निवारा भार",
  "Toilet Usage": "शौचालय वापर",
  "Food Zones": "अन्न क्षेत्रे",
  "Medical Camps": "वैद्यकीय शिबिरे",
  "Real-Time Command Timeline": "रिअल-टाइम कमांड टाइमलाइन",
  "Live operational event stream — all departments · escalations · AI actions · resolutions":
    "थेट कार्यान्वयन घटना प्रवाह — सर्व विभाग · वाढ · एआय कृती · निराकरणे",

  // ── DashboardHome — route/service/status/unit vocabulary ─────
  "Ramkund Ghat — Main Entry": "रामकुंड घाट — मुख्य प्रवेशद्वार",
  "Panchvati — Godavari Bridge": "पंचवटी — गोदावरी पूल",
  "Trimbakeshwar Temple Gate": "त्र्यंबकेश्वर मंदिर प्रवेशद्वार",
  "Nashik Road — Bus Terminal": "नाशिक रोड — बस टर्मिनल",
  "Kalaram Temple Corridor": "काळाराम मंदिर मार्गिका",
  "Gangapur Camp Zone": "गंगापूर कॅम्प झोन",
  "critical": "गंभीर",
  "high": "उच्च",
  "moderate": "मध्यम",
  "normal": "सामान्य",
  "dep": "तैनात",
  "avail": "उपलब्ध",
  "live": "थेट",
  "Total Deployed": "एकूण तैनात",
  "Available": "उपलब्ध",
  "Responding": "प्रतिसाद देत आहे",
  "Toilets": "शौचालये",
  "Water Stations": "पाणी केंद्रे",
  "Shelters": "निवारे",
  "Parking Lots": "वाहनतळ",
  "Food Zones": "अन्न क्षेत्रे",
  "Bus Bays": "बस बे",
  "Waste Points": "कचरा संकलन केंद्रे",

  // ── DashboardHome — emergency unit types (dept.name / unit.type set) ──
  "Police": "पोलीस",
  "Ambulance": "रुग्णवाहिका",
  "Fire": "अग्निशमन",
  "NDRF": "एनडीआरएफ",
  "Volunteers": "स्वयंसेवक",
  "Health": "आरोग्य",
  "Transport": "वाहतूक",
  "Municipal NMC": "एनएमसी महानगरपालिका",
  "Revenue": "महसूल",
  "deployed": "तैनात",
  "alerts": "इशारे",
  "Deployment": "तैनाती",
  "Resolution Rate": "निराकरण दर",

  // ── DashboardHome — kpiData titles (auto-translated by MetricCard) ──
  "Crowd Risk Index": "गर्दी जोखीम निर्देशांक",
  "Active Incidents": "सक्रिय घटना",
  "Emergency Responses": "आपत्कालीन प्रतिसाद",
  "Missing Persons": "बेपत्ता व्यक्ती",
  "Medical Cases": "वैद्यकीय प्रकरणे",
  "Transport Load": "वाहतूक भार",

  // ── DashboardHome — alertFeed (auto-translated by IncidentFeed) ──
  "Crowd surge at Ramkund Ghat — Entry 2": "रामकुंड घाट येथे गर्दी वाढ — प्रवेशद्वार 2",
  "Water station #8 at 91% capacity — Panchvati": "जल केंद्र #8 91% क्षमतेवर — पंचवटी",
  "Shuttle SR-04 delayed 22 min — Trimbakeshwar": "शटल SR-04 22 मिनिटे विलंबित — त्र्यंबकेश्वर",
  "Medical emergency — heatstroke Zone C Godavari": "वैद्यकीय आणीबाणी — उष्माघात झोन C गोदावरी",
  "Missing child reported at Panchvati Sector 7": "पंचवटी सेक्टर 7 येथे मूल बेपत्ता नोंदवले",
  "AI duplicate alert suppressed — Kalaram Zone": "एआय डुप्लिकेट सूचना दाबली — काळाराम झोन",
  "Shelter capacity 94% — Nashik Road Camp 3": "निवारा क्षमता 94% — नाशिक रोड कॅम्प 3",
  "Missing person resolved — ID #MP-1182": "बेपत्ता व्यक्ती सापडली — ओळख क्र. #MP-1182",
  "Fire alert suppressed (false positive) — Trimbak": "आग सूचना दाबली (खोटा इशारा) — त्र्यंबक",
  "New pilgrim guidance broadcast — Marathi/Hindi": "नवीन यात्रेकरू मार्गदर्शन प्रसारण — मराठी/हिंदी",
  "Municipal": "महानगरपालिका",
  "AI Assurance": "एआय अ‍ॅश्युरन्स",
  "Public Comms": "जनसंपर्क",
  "Monitoring": "निरीक्षणाधीन",
  "In Progress": "प्रगतीपथावर",
  "Responded": "प्रतिसाद दिला",
  "Auto-Closed": "स्वयं-बंद",
  "Closed": "बंद",
  "Validated": "सत्यापित",
  "Published": "प्रकाशित",
  "Active": "सक्रिय",
  "HIGH": "उच्च",
  "MED": "मध्यम",
  "LOW": "कमी",

  // ── DashboardHome — commandTimeline (code-wrapped: t(event.msg) / t(event.dept)) ──
  "DCP Nashik approved crowd diversion — Ramkund Entry 2": "DCP नाशिक यांनी गर्दी वळवण्यास मंजुरी दिली — रामकुंड प्रवेशद्वार 2",
  "CMO reviewed heatstroke flag — Zone D, AI confidence 78%": "CMO ने उष्माघात सूचनेचे पुनरावलोकन केले — झोन D, एआय विश्वासार्हता 78%",
  "Missing child MP-1185 registered — Panchvati Sector 7": "बेपत्ता मूल MP-1185 नोंदवले — पंचवटी सेक्टर 7",
  "AI duplicate fire alert suppressed — Trimbak Zone A": "एआय डुप्लिकेट आग सूचना दाबली — त्र्यंबक झोन A",
  "Missing person MP-1182 located and reunited": "बेपत्ता व्यक्ती MP-1182 सापडली आणि कुटुंबाशी भेट झाली",
  "Extra MSRTC buses deployed — Nashik Road → Ramkund": "अतिरिक्त MSRTC बस तैनात — नाशिक रोड → रामकुंड",
  "Shelter Camp 3 at 94% — escalated to Revenue Dept": "निवारा कॅम्प 3 94% वर — महसूल विभागाकडे वाढवले",
  "Godavari Bridge congestion cleared — Police escort": "गोदावरी पूल वाहतूक कोंडी दूर — पोलीस बंदोबस्तात",
  "Public advisory broadcast — Marathi/Hindi — 82K reach": "सार्वजनिक सूचना प्रसारण — मराठी/हिंदी — 82K पोहोच",
  "System": "प्रणाली",
  "Comms": "संपर्क",

  // ── DashboardHome — Maha Kumbh AI Difference footer ──────────────────
  "The Maha Kumbh AI Difference": "महा कुंभ एआय मधील फरक",
  '"Existing Kumbh AI Stack senses events. Maha Kumbh AI validates, predicts, orchestrates response and creates trusted, auditable governance for Simhastha-scale operations."':
    '"सध्याचा कुंभ एआय स्टॅक घटना जाणतो. महा कुंभ एआय सत्यापित करते, अंदाज वर्तवते, प्रतिसाद समन्वयित करते आणि सिंहस्थ-स्तरीय कार्यान्वयनासाठी विश्वासार्ह, लेखापरीक्षणयोग्य प्रशासन निर्माण करते."',
  "AI Validation": "एआय सत्यापन",
  "Every AI alert reviewed before action": "प्रत्येक एआय अलर्टचे कृतीपूर्वी पुनरावलोकन केले जाते",
  "Crowd Prediction": "गर्दी अंदाज",
  "4-hour ahead crowd risk forecasting": "4 तास आधीचा गर्दी जोखीम अंदाज",
  "Privacy First": "गोपनीयता प्रथम",
  "DPDP 2023 · no autonomous enforcement": "डीपीडीपी 2023 · कोणतीही स्वायत्त अंमलबजावणी नाही",
  "Audit Trail": "लेखापरीक्षण मागोवा",
  "Complete governance log for all actions": "सर्व कृतींसाठी संपूर्ण प्रशासन नोंद",
  '"AI for Public Safety. AI for Trust. AI for Governance."':
    '"सार्वजनिक सुरक्षिततेसाठी एआय. विश्वासासाठी एआय. प्रशासनासाठी एआय."',

  // ── ExecutiveIntelligence.jsx ─────────────────────────────────
  "Executive Decision Intelligence": "एक्झिक्युटिव्ह निर्णय गुप्तचर प्रणाली",
  "CM & Collector strategic command · budget burn · department KPIs · risk heatmap · Shahi Snan readiness · policy compliance · decision log · Maha AI governance layer — Simhastha 2027":
    "मुख्यमंत्री आणि जिल्हाधिकारी सामरिक कमांड · अर्थसंकल्प खर्च · विभाग केपीआय · जोखीम हीटमॅप · शाही स्नान सज्जता · धोरण अनुपालन · निर्णय नोंद · महा एआय प्रशासन स्तर — सिंहस्थ 2027",
  "CM LIVE": "सीएम थेट",
  "decisions today": "आजचे निर्णय",
  "→ Full multi-hazard risk breakdown": "→ संपूर्ण बहु-धोका जोखीम तपशील",
  "Budget Burn": "अर्थसंकल्प खर्च",
  "Total Allocated": "एकूण वाटप",
  "Burn Rate": "खर्च दर",
  "Modules Live": "कार्यरत मॉड्यूल्स",
  "Decisions Today": "आजचे निर्णय",
  "Policy Score": "धोरण गुण",
  "Next Shahi Snan": "पुढील शाही स्नान",
  "MAHA AI — EXECUTIVE INTELLIGENCE · CM OFFICE CONNECTED · 14:35 IST":
    "महा एआय — एक्झिक्युटिव्ह इंटेलिजन्स · मुख्यमंत्री कार्यालय कनेक्टेड · 14:35 आयएसटी",
  "Simhastha 2027 — Mission-Critical Governance Command": "सिंहस्थ 2027 — मिशन-क्रिटिकल प्रशासन कमांड",
  "6 departments · ₹808 Cr burn (67%) · composite risk 62/100 · 20 Maha Kumbh AI modules live · 44 decisions today · 7 policy frameworks compliant · Next Shahi Snan: 32 days":
    "6 विभाग · ₹808 कोटी खर्च (67%) · एकत्रित जोखीम 62/100 · 20 महा कुंभ एआय मॉड्यूल्स कार्यरत · आज 44 निर्णय · 7 धोरण चौकटी अनुपालित · पुढील शाही स्नान: 32 दिवस",
  "vs": "वि.",
  "target": "उद्दिष्ट",
  "Multi-Domain Risk Heatmap": "बहु-क्षेत्रीय जोखीम हीटमॅप",
  "Composite risk score per domain — threshold 60": "प्रत्येक क्षेत्रासाठी एकत्रित जोखीम गुण — उंबरठा 60",
  "Threshold": "उंबरठा",
  "Current Score": "सद्य गुण",
  "Composite Risk Index — Hourly Trend": "एकत्रित जोखीम निर्देशांक — तासागणिक कल",
  "Overall + crowd + flood + health risk curves across the day": "दिवसभरातील एकूण + गर्दी + पूर + आरोग्य जोखीम आलेख",
  "Composite": "एकत्रित",
  "Crowd": "गर्दी",
  "Flood": "पूर",
  "Department Performance Scorecard": "विभाग कामगिरी स्कोअरकार्ड",
  "All 6 departments — target vs actual · budget burn · staff · SLA compliance":
    "सर्व 6 विभाग — उद्दिष्ट वि. प्रत्यक्ष · अर्थसंकल्प खर्च · कर्मचारी · एसएलए अनुपालन",
  "Department": "विभाग",
  "Target": "उद्दिष्ट",
  "Gap": "तफावत",
  "Staff": "कर्मचारी",
  "Incidents": "घटना",
  "SLA %": "एसएलए %",
  "Disaster Management": "आपत्ती व्यवस्थापन",
  "Police Modernization": "पोलीस आधुनिकीकरण",
  "Governance IT": "प्रशासन आयटी",
  "Command Centers": "कमांड केंद्रे",
  "Resilience Infra": "स्थितिस्थापक पायाभूत सुविधा",
  "Emergency Systems": "आपत्कालीन प्रणाली",
  "Public Safety": "सार्वजनिक सुरक्षा",
  "AI Governance": "एआय प्रशासन",
  "Budget Allocation by Category": "प्रकारानुसार अर्थसंकल्प वाटप",
  "Allocated": "वाटप केलेले",
  "Spent": "खर्च केलेले",
  "Budget Share by Category": "प्रकारानुसार अर्थसंकल्प वाटा",
  "Proportion of ₹1,200 Cr total Simhastha 2027 allocation": "₹1,200 कोटी एकूण सिंहस्थ 2027 वाटपाचे प्रमाण",
  "Disaster Mgmt": "आपत्ती व्यवस्थापन",
  "Police Modern.": "पोलीस आधुनिकीकरण",
  "Emergency Sys.": "आपत्कालीन प्रणाली",
  "Strategic Decision Log — Today": "सामरिक निर्णय नोंद — आज",
  "High-level decisions by DCP / Collector / CM Office with impact and execution status":
    "डीसीपी / जिल्हाधिकारी / मुख्यमंत्री कार्यालय यांचे उच्च-स्तरीय निर्णय, परिणाम आणि अंमलबजावणी स्थितीसह",
  "By:": "द्वारे:",
  "Approve crowd diversion plan — Ramkund Entry 2": "गर्दी वळवण्याची योजना मंजूर — रामकुंड प्रवेशद्वार 2",
  "Pre-position NDRF Platoon 2 at Camp 3": "एनडीआरएफ प्लाटून 2 कॅम्प 3 येथे पूर्व-तैनात",
  "Activate overflow shelter OFZ-B — 138% capacity": "अतिप्रवाह निवारा OFZ-B सक्रिय — 138% क्षमता",
  "CM convoy route POL-002 approved — 15:30 ingress": "मुख्यमंत्री ताफा मार्ग POL-002 मंजूर — 15:30 प्रवेश",
  "Issue city-wide heat advisory — 6 languages": "शहरव्यापी उष्णता सूचना जारी — 6 भाषा",
  "Budget supplementary ₹12 Cr — extra ambulance deployment": "पूरक अर्थसंकल्प ₹12 कोटी — अतिरिक्त रुग्णवाहिका तैनाती",
  "Mutual aid NDRF Aurangabad — 2 platoons requested": "परस्पर सहाय्य एनडीआरएफ औरंगाबाद — 2 प्लाटून विनंती",
  "DCP Nashik": "डीसीपी नाशिक",
  "Dist. Collector": "जिल्हाधिकारी",
  "SP Nashik": "एसपी नाशिक",
  "CMO Nashik": "सीएमओ नाशिक",
  "CM Office": "मुख्यमंत्री कार्यालय",
  "DM Nashik": "डीएम नाशिक",
  "Executed": "अंमलात आणले",
  "Pending": "प्रलंबित",
  "Approved": "मंजूर",
  "Shahi Snan Readiness Index": "शाही स्नान सज्जता निर्देशांक",
  "Budget · staff · infrastructure readiness per upcoming Shahi Snan event":
    "प्रत्येक आगामी शाही स्नान कार्यक्रमासाठी अर्थसंकल्प · कर्मचारी · पायाभूत सुविधा सज्जता",
  "11 Jul — Shravan Purnima": "11 जुलै — श्रावण पौर्णिमा",
  "12 Aug — Simhastha Peak": "12 ऑगस्ट — सिंहस्थ शिखर",
  "14 Sep — Anant Chaturdashi": "14 सप्टेंबर — अनंत चतुर्दशी",
  "days away": "दिवस बाकी",
  "Est. crowd:": "अंदाजित गर्दी:",
  "overall": "एकूण",
  "Budget": "अर्थसंकल्प",
  "Infra": "पायाभूत सुविधा",
  "Policy & Regulatory Compliance": "धोरण आणि नियामक अनुपालन",
  "7 active compliance frameworks — score and status": "7 सक्रिय अनुपालन चौकटी — गुण आणि स्थिती",
  "DPDP 2023 — Data Protection": "डीपीडीपी 2023 — डेटा संरक्षण",
  "Disaster Management Act 2005": "आपत्ती व्यवस्थापन कायदा 2005",
  "Police Reforms — Transparency": "पोलीस सुधारणा — पारदर्शकता",
  "RTI Compliance": "आरटीआय अनुपालन",
  "Environmental Clearances": "पर्यावरण मंजुरी",
  "Labour Safety — Crowd Workers": "कामगार सुरक्षा — गर्दी कामगार",
  "IT Act 2000 — Cyber Infrastructure": "आयटी कायदा 2000 — सायबर पायाभूत सुविधा",
  "Compliant": "अनुपालित",
  "Review": "पुनरावलोकन",

  // ── RiskIntelligence.jsx ──────────────────────────────────────
  "Multi-Hazard Predictive Risk Intelligence": "बहु-आपत्ती पूर्वानुमानित जोखीम गुप्तचर प्रणाली",
  "Composite risk engine · flood · stampede · heat · epidemic · fire · infrastructure · compound scenarios · weather · AI-driven 6-hour forecast — Maha AI · Simhastha 2027":
    "एकत्रित जोखीम इंजिन · पूर · चेंगराचेंगरी · उष्णता · साथरोग · आग · पायाभूत सुविधा · संयुक्त परिस्थिती · हवामान · एआय-चालित 6-तास अंदाज — महा एआय · सिंहस्थ 2027",
  "RISK: 62/100": "जोखीम: 62/100",
  "Composite Risk": "एकत्रित जोखीम",
  "Crowd Stampede": "गर्दी चेंगराचेंगरी",
  "Flood Risk": "पूर जोखीम",
  "Heat / Health": "उष्णता / आरोग्य",
  "Fire Risk": "आग जोखीम",
  "Epidemic Risk": "साथरोग जोखीम",
  "Infra Risk": "पायाभूत सुविधा जोखीम",
  "Rain Probability": "पावसाची शक्यता",
  "MAHA AI — MULTI-HAZARD RISK ENGINE · AI FORECAST HORIZON 6H · 14:35 IST":
    "महा एआय — बहु-आपत्ती जोखीम इंजिन · एआय अंदाज क्षितिज 6 तास · 14:35 आयएसटी",
  "Composite Risk: 62/100 — ELEVATED": "एकत्रित जोखीम: 62/100 — वाढलेली",
  "Crowd risk dominant (78) · heat index 46°C (peak 16:00–17:00) · Godavari level 4.2m ↑ · 1 compound scenario at 28% probability · All hazard teams on alert":
    "गर्दी जोखीम प्रबळ (78) · उष्णता निर्देशांक 46°C (शिखर 16:00–17:00) · गोदावरी पातळी 4.2मी ↑ · 28% संभाव्यतेसह 1 संयुक्त परिस्थिती · सर्व आपत्ती पथके सतर्क",
  "Heat": "उष्णता",
  "Epidemic": "साथरोग",
  "Prev": "मागील",
  "Flood / Flash": "पूर / फ्लॅश पूर",
  "Infra Failure": "पायाभूत सुविधा अपयश",
  "Zone × Hazard Risk Matrix": "क्षेत्र × आपत्ती जोखीम मॅट्रिक्स",
  "Risk scores per zone across all 4 primary hazards (crowd · flood · heat · fire)":
    "सर्व 4 प्रमुख आपत्तींमधील क्षेत्रानुसार जोखीम गुण (गर्दी · पूर · उष्णता · आग)",
  "Zone": "झोन",
  "Ramkund Ghat": "रामकुंड घाट",
  "Panchvati": "पंचवटी",
  "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Nashik Road": "नाशिक रोड",
  "Gangapur Camp": "गंगापूर कॅम्प",
  "Kalaram Temple": "काळाराम मंदिर",
  "Ramkund": "रामकुंड",
  "Trimbak": "त्र्यंबक",
  "Nashik Rd": "नाशिक रोड",
  "AI Stampede Risk Forecast — Next 6 Hours": "एआय चेंगराचेंगरी जोखीम अंदाज — पुढील 6 तास",
  "Zone-wise crowd stampede probability (0–100) · AI confidence 89%":
    "क्षेत्रनिहाय गर्दी चेंगराचेंगरी संभाव्यता (0–100) · एआय विश्वासार्हता 89%",
  "⚠ AI prediction — human review required before evacuation orders. DPDP 2023 compliant.":
    "⚠ एआय अंदाज — स्थलांतर आदेशापूर्वी मानवी पुनरावलोकन आवश्यक. डीपीडीपी 2023 अनुपालित.",
  "→ View this model's accuracy record": "→ या मॉडेलची अचूकता नोंद पहा",
  "Godavari River — Level & Discharge Forecast": "गोदावरी नदी — पातळी आणि विसर्ग अंदाज",
  "Gangapur Dam discharge · river level (m) · upstream rainfall — Nashik":
    "गंगापूर धरण विसर्ग · नदी पातळी (मी) · उगमाकडील पर्जन्यमान — नाशिक",
  "⚠ Alert Level: 5.0m": "⚠ सतर्कता पातळी: 5.0मी",
  "Critical Level: 6.0m": "गंभीर पातळी: 6.0मी",
  "Current:": "सद्य:",
  "Discharge (cumecs)": "विसर्ग (क्युमेक्स)",
  "River Level (m)": "नदी पातळी (मी)",
  "Rainfall (mm)": "पर्जन्यमान (मिमी)",
  "IMD Weather Impact Forecast — Nashik (Next 6 Hours)": "आयएमडी हवामान परिणाम अंदाज — नाशिक (पुढील 6 तास)",
  "Temperature · heat index · UV · wind speed · rainfall probability":
    "तापमान · उष्णता निर्देशांक · यूव्ही · वाऱ्याचा वेग · पावसाची शक्यता",
  "Time": "वेळ",
  "Temp °C": "तापमान °C",
  "Heat Index": "उष्णता निर्देशांक",
  "Humidity %": "आर्द्रता %",
  "UV Index": "अतिनील निर्देशांक",
  "Wind km/h": "वारा किमी/तास",
  "Rain %": "पाऊस %",
  "Epidemic & Disease Surveillance — Risk Watch": "साथरोग आणि रोग सर्वेक्षण — जोखीम निरीक्षण",
  "Active surveillance across 5 disease vectors · R₀ estimates · case trend":
    "5 रोग वाहकांमधील सक्रिय सर्वेक्षण · R₀ अंदाज · प्रकरण कल",
  "Disease": "रोग",
  "Cases 24h": "24 तासांतील प्रकरणे",
  "Trend": "कल",
  "Risk": "जोखीम",
  "Load vs Threshold": "भार वि. उंबरठा",
  "Heatstroke": "उष्माघात",
  "Gastroenteritis": "जठरांत्रशोथ",
  "Respiratory (ARI)": "श्वसन (एआरआय)",
  "Cholera (watch)": "कॉलरा (निरीक्षण)",
  "Dengue (vector)": "डेंग्यू (वाहक)",
  "Compound Risk Scenarios — Pre-Modelled": "संयुक्त जोखीम परिस्थिती — पूर्व-मॉडेल्ड",
  "CRITICAL": "गंभीर",
  "AI prob:": "एआय संभाव्यता:",
  "Trigger:": "कारण:",
  "Window:": "कालावधी:",
  "Anytime": "कधीही",
  "Crowd + Heat Compound Event": "गर्दी + उष्णता संयुक्त घटना",
  "Flash Flood + Crowd Displacement": "अचानक पूर + गर्दी विस्थापन",
  "Power Grid + Comms Failure": "वीज ग्रीड + संपर्क अपयश",
  "Crowd density >9/m² + Heat index >46°C": "गर्दी घनता >9/मी² + उष्णता निर्देशांक >46°C",
  "Gangapur Dam discharge >350 cumecs + rainfall >15mm/hr": "गंगापूर धरण विसर्ग >350 क्युमेक्स + पर्जन्यमान >15मिमी/तास",
  "Substation overload + generator failure Zone B": "उपकेंद्र अतिभार + जनरेटर अपयश झोन बी",
  "Stampede risk at Ramkund": "रामकुंड येथे चेंगराचेंगरी जोखीम",
  "Mass heatstroke cases": "मोठ्या प्रमाणात उष्माघात प्रकरणे",
  "Ambulance demand surge +200%": "रुग्णवाहिका मागणीत +200% वाढ",
  "Godavari Ghat evacuation": "गोदावरी घाट स्थलांतर",
  "Camp 3 inundation risk": "कॅम्प 3 पूरग्रस्त होण्याची जोखीम",
  "Road closures — 4 routes": "रस्ते बंद — 4 मार्ग",
  "Maha Kumbh AI monitoring blackout 12 min": "महा कुंभ एआय निरीक्षण खंड 12 मिनिटे",
  "Crowd management loss": "गर्दी व्यवस्थापन तोटा",
  "Emergency services impact": "आपत्कालीन सेवांवर परिणाम",
  "Expected Impacts": "अपेक्षित परिणाम",
  "Pre-Planned Mitigations": "पूर्व-नियोजित उपाययोजना",
  "Deploy crowd dispersal at 15:30": "15:30 वाजता गर्दी विखुरवणी तैनात करा",
  "Activate 4 additional medical posts": "4 अतिरिक्त वैद्यकीय चौक्या सक्रिय करा",
  "Issue advisory 90 min before": "90 मिनिटे आधी सूचना जारी करा",
  "Pre-position 2 NDRF platoons": "2 एनडीआरएफ प्लाटून पूर्व-तैनात करा",
  "Open overflow shelter OFZ-A": "अतिप्रवाह निवारा OFZ-A सुरू करा",
  "Halt Godavari Ghat access at 17:00": "17:00 वाजता गोदावरी घाट प्रवेश थांबवा",
  "DG backup pre-armed": "डीजी बॅकअप पूर्व-सज्ज",
  "VSAT backup comms live": "व्हीसॅट बॅकअप संपर्क कार्यरत",
  "Manual protocols pre-briefed": "मॅन्युअल प्रोटोकॉल पूर्व-माहिती दिलेले",
  "Critical Infrastructure Risk Monitor": "गंभीर पायाभूत सुविधा जोखीम निरीक्षक",
  "Load vs capacity for 5 key assets — alert above 80% load": "5 प्रमुख मालमत्तांसाठी भार वि. क्षमता — 80% भारापेक्षा जास्त झाल्यास सतर्कता",
  "Godavari Bridge": "गोदावरी पूल",
  "Trimbak Road": "त्र्यंबक रोड",
  "MSEDCL Feeder Z-A": "एमएसईडीसीएल फीडर Z-A",
  "Water Pumping Stn 8": "जल उपसा केंद्र 8",
  "BSNL Tower TK-04": "बीएसएनएल टॉवर TK-04",
  "Monitor": "निरीक्षणाधीन",
  "OK": "ठीक",
  "risk score": "जोखीम गुण",
};

export default shard1;
